import { PropsWithChildren, useEffect, useState } from 'react';
import { t } from 'services/i18n.service';
import { useAppDispatch } from 'store/hooks';
import { updatePackMarketPlaceRequestStatus } from 'store/reducer/habit-pack/extra';
import { copyPackLink } from 'utils/helpers';
import { HabitPackType } from 'interfaces/common.interface';
import { MarketplaceRequestStatus } from 'enums';
import { toast } from 'react-toastify';
import { MODAL_TYPES } from 'constants/general';
import { updateConfirmActionModal } from 'store/reducer/modal/slice';
import { ATTRIB } from 'constants/test';

const Wrapper = ({ children }: PropsWithChildren) => (
  <div className='w-full flex flex-col items-center gap-y-6'>{children}</div>
);

export default function PackMarketplaceControls({
  habitPack
}: {
  readonly habitPack: HabitPackType;
}) {
  const [action, setAction] = useState({
    info: '',
    button: ''
  });
  const dispatch = useAppDispatch();
  const approvalNotRequested =
    habitPack.marketplace_request === MarketplaceRequestStatus.UNREQUESTED ||
    habitPack.marketplace_request === null;

  useEffect(() => {
    let updateAction = {
      info: t('packs.pre_request_text'),
      button: t('packs.btn_publish')
    };

    if (habitPack.marketplace_approval_status) {
      updateAction = {
        info: t('packs.remove_text'),
        button: t('packs.btn_remove')
      };
    }

    if (habitPack.marketplace_request === MarketplaceRequestStatus.REQUESTED) {
      updateAction = {
        info: t('packs.post_request_text'),
        button: t('packs.btn_cancel_request')
      };
    }

    setAction(updateAction);
  }, [habitPack, approvalNotRequested]);

  const handleMarketplaceRequestAction = () => {
    if (habitPack.marketplace_approval_status) {
      dispatch(
        updateConfirmActionModal({
          modalType:
            MODAL_TYPES.CONFIRM_ACTION_REMOVE_HABIT_PACK_FROM_MARKET_PLACE,
          confirmTitle: t('packs.btn_remove'),
          showConfirmModal: true
        })
      );
    } else {
      dispatch(
        updatePackMarketPlaceRequestStatus({
          habitPack,
          status:
            habitPack.marketplace_request === MarketplaceRequestStatus.REQUESTED
              ? MarketplaceRequestStatus.UNREQUESTED
              : MarketplaceRequestStatus.REQUESTED
        })
      );
    }
  };

  return (
    <Wrapper>
      <p className='text-sm md:text-md w-[90%] md:w-[70%]'>{action.info}</p>
      <button
        data-testid={ATTRIB.DATA_TESTID.MARKETPLACE_ACTION_BUTTON}
        onClick={handleMarketplaceRequestAction}
        className='w-3/4 sm:w-1/2 md:w-[50%] px-2 py-1 md:px-2 md:py-1 text-xs sm:text-base rounded-xl border-2 border-blue-500 text-blue-500  font-bold hover:text-white hover:bg-blue-500'>
        {action.button}
      </button>
      <p className='w-[70%] text-sm md:text-md'>
        {t('packs.share_using_link')}
      </p>
      <button
        data-testid={ATTRIB.DATA_TESTID.COPY_LINK_BUTTON}
        onClick={() => {
          copyPackLink(habitPack.id);
          toast.info(t('packs.copied'), {
            position: 'bottom-center',
            theme: 'colored'
          });
        }}
        className='text-orange-500 underline'>
        {t('packs.copy_link')} 🔗
      </button>
    </Wrapper>
  );
}
